module.exports = __webpack_public_path__ + "img/signature@2x.13c57b1.webp";